<script>
  //// router : https://gitlab.inria.fr/ink-interaction/list-widgets/-/tree/master/node_modules/svelte-spa-router
  import Router, { location, link } from "svelte-spa-router";
  import Navbar from "../src/components/NavBar.svelte";
  // Include our Routes
  //import { routes } from "./routes.js";
  import Home from "./routes/Home.svelte";
  import Personne from "./routes/Personne.svelte";
  import PersonnesPartiesListe from "./components/PersonnesPartiesListe.svelte";
  import Personneliste_card from "./components/Personneliste_card.svelte";

  import MouvementsEffectif from "./components/MouvementsEffectif.svelte";
  import SalaireInfo from "./components/SalaireInfo.svelte";
  import SalaireAugmentation from "./components/SalaireAugmentation.svelte";
  import SalaireHistoPrimes from "./components/SalaireHistoPrimes.svelte";
  import PersonnePositionSalaire from "./components/PersonnePositionSalaire.svelte";

  import Test from "./components/Show.svelte";

  import NotFound from "./routes/NotFound.svelte";
</script>

<header>
  <Navbar />
</header>

<main>
  <Router
    routes={{
      "/": Home,
      "/listecard": Personneliste_card,
      "/partis": PersonnesPartiesListe,
      "/mouvt": MouvementsEffectif,
      "/personne/:id": Personne,

      "/salposition": PersonnePositionSalaire,
      "/salinfo": SalaireInfo,
      "/salprimes": SalaireHistoPrimes,
      "/salaugment": SalaireAugmentation,

      "/test": Test,

      "*": NotFound,
    }}
  />
</main>

<style>
  main,
  header {
    padding: 20px;
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  }
</style>
